import { createContext } from 'react'
import type { ShadowModel } from '../Shadows/types'
import {
    DEFAULT_MODEL_VIEWER_PRESENTATION_SETUP,
    type ModelViewerPresentationSetup,
} from '../Presentation/Setup'
import type { ModelViewerMode } from '../ViewerMode'

export interface RenderingContextValue {
    fabricLighting?: boolean
    modelRevision?: number
    presentationSetup: ModelViewerPresentationSetup
    shadowCacheKey: string
    viewerMode: ModelViewerMode
    reportCenteredModel?: (model: ShadowModel) => void
}

const RenderingContext = createContext<RenderingContextValue>({
    presentationSetup: DEFAULT_MODEL_VIEWER_PRESENTATION_SETUP,
    shadowCacheKey: '',
    viewerMode: 'standalone',
})

export default RenderingContext
